import {APP_INITIALIZER, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {SharedModule} from './shared/shared.module';
import {CoreModule} from './core/core.module';
import {REGION} from '@angular/fire/functions';
import {AppInitService} from './core/service/app-init.service';
import {DatePipe} from '@angular/common';
import {RouteReuseStrategy} from '@angular/router';
import {CustomRouteReuseStrategy} from './core/routeReuseStrategy/custom-route-reuse-strategy';
import {HttpClient} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {NabelTranslateService} from './../app/core/service/nabel-translate.service';

/**
 *
 * @param appInitService
 */
export function initializeApp(appInitService: AppInitService) {
  return (): Promise<any> => {
    return appInitService.Init();
  };
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: NabelTranslateService,
        deps: [HttpClient],
      }
    }),
  ],
  providers: [{provide: REGION, useValue: 'asia-northeast1'}, DatePipe,
    {provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppInitService], multi: true},
    {provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
